export enum LabelTypesEnum {
  COMPANY_LOGO,
  COMPANY_DESCRIPTION,
  FULL_NAME,
  EMAIL,
  PASSWORD,
  PHONE_NUMBER,
  PERSONAL_INFO,
}
export enum UpdatePhotos {
  LOGO = 'logo',
  PERSONAL_PHOTO = 'personalPhoto',
}
export enum PersonalInfoItems {
  AGE = 'age',
  GENDER = 'gender',
  MARITAL_STATUS = 'maritalStatus',
  EDUCATION = 'education',
  INDUSTRY = 'industry',
  POSITION = 'position',
  PURCHASE_INFO = 'purchaseInfo',
  PURCHASE_PURPOSE = 'purchasePurpose',
  PURCHASE_FINANCING = 'purchaseFinancing',
  PURCHASE_TIME_FRAME = 'purchaseTimeframe',
}

export enum SubscriptionStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  FAILED = 'FAILED',
  GRACE_PERIOD = 'GRACE_PERIOD',
}
